<template>
    <b-list-group-item class="intake-dashboard-data mb-4 p-0" v-if="overview">
        <div class="p-2 pl-3 text-left">
            <span class="text-muted text-uppercase font-weight-bold font-sub-label pr-1">Check</span><span class="text-black-50 font-lg font-weight-bold pr-4">{{ data.company_check }}</span>
            <span class="text-muted text-uppercase font-weight-bold font-sub-label pr-1">Direct Deposit</span><span class="text-black-50 font-lg font-weight-bold pr-4">{{ data.direct_deposit }}</span>
            <span class="text-muted text-uppercase font-weight-bold font-sub-label pr-1">PayPal</span><span class="text-black-50 font-lg font-weight-bold pr-4">{{ data.paypal }}</span>
            <span class="text-muted text-uppercase font-weight-bold font-sub-label pr-1">Failed</span><span class="text-black-50 font-lg font-weight-bold">{{ data.failed }}</span>
        </div>
        <div class="pl-3 text-left float-left">
            <span class="text-muted text-uppercase font-weight-bold font-sub-label pr-1">Total</span>
            <span class="data-number" :class="colorDataClass" v-if="data.total !== undefined">{{ data.total }}</span>
            <span class="data-number" v-else><b-spinner type="grow" variant="secondary"></b-spinner></span>
        </div>
        <div class="pr-3 text-right">
            <span class="data-number" :class="colorDataClass" v-if="data.total_amount !== undefined">${{ data.total_amount | toFixed2 }}</span>
            <span class="data-number" v-else><b-spinner type="grow" variant="secondary"></b-spinner></span>
        </div>
        <div class="dashboard-nav-highlight"></div>
    </b-list-group-item>
    
    <b-list-group-item class="intake-dashboard-data intake-dashboard-data-set-height mb-4 p-0" v-else>
        <div class="mr-1 position-relative force-box-size" :class="colorAccentClass">
            <i class="p-4--void font-2xl--void icon-shift-position" :class="[icon, colorIconClass]"></i>
            <div class="position-absolute--void w-100--void text-center mb-2--void text-uppercase icon-label--void" :class="colorIconClass">{{ label }}</div>

        </div>
        <div class="p-2 pr-3 text-right payments-data-slots">
            <span class="text-muted text-uppercase font-weight-bold font-sub-label pr-1">Outstanding</span><span class="text-primary font-lg font-weight-bold pr-2">{{ data.outstanding }}</span>
            <span class="text-muted text-uppercase font-weight-bold font-sub-label pr-1">Processed</span><span class="text-success font-lg font-weight-bold pr-2">{{ data.processed }}</span>
            <span class="text-muted text-uppercase font-weight-bold font-sub-label pr-1">Total</span><span class="text-black-50 font-lg font-weight-bold">{{ data.total }}</span>
        </div>
        <div class="pr-3 text-right">
            <span class="data-number" :class="colorDataClass" v-if="data.total_amount !== undefined">${{ data.total_amount | toFixed2 }}</span>
            <span class="data-number" v-else><b-spinner type="grow" variant="secondary"></b-spinner></span>
        </div>
        <div class="dashboard-nav-highlight"></div>
    </b-list-group-item>
</template>

<script>
    export default {
        name: 'PaymentsSideDataWidget',
        props: {
            label: String,
            data: {
                type: Object,
                default: null
            },
            icon: {
                type: String,
                default: 'fa-light fa-analytics',
            },
            overview: {
                type: Boolean,
                default: false,
            },
            colorAccent: {
                type: String,
                default: 'gray-700',
            },
            colorData: {
                type: String,
                default: 'dark',
            },
            colorIcon: {
                type: String,
                default: 'white',
            }
        },
        computed: {
            colorAccentClass() {
                return this.colorAccent !== '' ? 'bg-' + this.colorAccent : 'bg-gray-700';
            },
            colorDataClass() {
                return this.colorData !== '' ? 'text-' + this.colorData : 'text-dark';
            },
            colorIconClass() {
                return this.colorIcon !== '' ? 'text-' + this.colorIcon : 'text-white';
            },
        }
    };
</script>

<style scoped>
    .intake-dashboard-data {
        padding: 0.3rem;
        border: 1px solid #d1d4d7;
        height: auto;
    }

    .intake-dashboard-data.clickable {
        cursor: pointer;
    }
    .intake-dashboard-data.clickable .dashboard-nav-highlight {
        background: #20a8d8;
        height: 3px;
        position: absolute;
        z-index: -1;
        right: 100%;
        bottom: 0;
        left: 0;
        /*transition: all 0.2s ease;*/
    }

    .intake-dashboard-data.clickable:hover .dashboard-nav-highlight {
        right: 0;
    }

    .icon-label {
        font-size: 8px;
        text-transform: uppercase;
        bottom: 0;
    }

    .icon-shift-position {
        position: relative;
        font-size: inherit;
    }

    .icon-shift-position::before {
        position: relative;
        top: -3px;
    }

    .data-number {
        font-size: 1.2rem;
        font-weight: bold;
        line-height: 1.5rem;
    }

    .font-sub-label {
        font-size: .6rem;

    }

    .force-box-size {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 2rem;
        font-size: .8rem;
        width: 100%;
    }
    .icon-shift-position {
        font-size: inherit;
        position: relative;
        top: 3px;
        margin-right: 6px;
    }
    .payments-data-slots {
        display: flex;
        flex-direction: column;
    }
    @media (min-width: 1440px) {
        .payments-data-slots {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: baseline;
        }
    }
    @media (min-width: 1760px) {
        .data-number {
            font-size: 2rem;
        }
        .intake-dashboard-data-set-height {
            height: 74px;
        }
        .force-box-size {
            width: 80px;
            height: 74px;
            text-align: center;
            float: left;
            font-size: .5rem;
            flex-direction: column;
        }
        .icon-shift-position {
            font-size: 20px;
            top: 0;
            margin: 0;
        }
    }
</style>